import React, { Fragment, useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { clone, concat, toString } from "ramda";
import { isBlank, notBlank } from "../../../util/ext";

// import InputBase from "@material-ui/core/InputBase";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: "black",
      "& p": {
        color: "black",
      },
    },
    overflow: "visible",
    padding: theme.spacing(0, 6),
  },

  dates: {
    padding: theme.spacing(0, 5.5, 2, 5.5),
    fontWeight: "bold",
  },
}));

const formatDate = date => {
  const zeros = {
    1: "000",
    2: "00",
    3: "0",
  };
  const newDate = date.length < 4 ? concat(zeros[date.length], date) : date;

  return `${newDate}-01-01T00:00:00Z`;
};

const ContentFacetPublicationYearSlider = props => {
  const { facet, dates, handleDateRangeSelected } = props;
  const classes = useStyles();

  const [value, setValue] = useState([]);
  useEffect(() => {
    if (notBlank(dates)) {
      setValue(dates);
    }
  }, [dates]);

  const facetClone = clone(facet);

  const handleChange = (event, newValue) => setValue(newValue);

  const handleChangeCommitted = useCallback(
    (event, newValue) => {
      const startDate = formatDate(toString(newValue[0]));
      const endDate = formatDate(toString(newValue[1]));

      facetClone.terms = [
        {
          start: newValue[0],
          end: newValue[1],
          code: `${startDate}|${endDate}`,
          label: `${newValue[0]} - ${newValue[1]}`,
        },
      ];
      // console.log(newValue);

      handleDateRangeSelected(facetClone);
      setValue(newValue);
      event.preventDefault();
    },
    [facetClone, handleDateRangeSelected],
  );

  // const changeStartDate = event => {
  //   console.log(Number(event.target.value));
  //   const newStartDate = Number(event.target.value);

  //   setValue(prev => {
  //     const [start, end] = prev;
  //     if (isNaN(newStartDate)) {
  //       return [1, end];
  //     } else {
  //       return [newStartDate, end];
  //     }
  //   });
  // };

  // const changeEndDate = event => {
  //   console.log(Number(event.target.value));
  //   const newEndDate = Number(event.target.value);

  //   setValue(prev => {
  //     const [start, end] = prev;
  //     if (isNaN(newEndDate)) {
  //       return [start, 2021];
  //     } else {
  //       return [start, newEndDate];
  //     }
  //   });
  // };

  return (
    <Fragment>
      <MenuItem tabIndex={0} classes={{ root: classes.root }} disableRipple>
        {isBlank(facet.terms) ? (
          <div></div>
        ) : (
          <Slider
            value={value}
            min={1}
            max={new Date().getFullYear()}
            onChange={handleChange}
            onChangeCommitted={handleChangeCommitted}
            valueLabelDisplay="auto"
          />
        )}
      </MenuItem>
      <Grid className={classes.dates} container justify="space-between">
        <Grid item xs={1}>
          {value[0]}
        </Grid>
        <Grid item xs={1}>
          {value[1]}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ContentFacetPublicationYearSlider;
